jQuery(function($){
    $(document).on("mouseenter", ".hover-trigger", function(e) {
        $(this).addClass('hovering');
    });

    $(document).on("mouseleave", ".hover-trigger", function(e) {
        $(this).removeClass('hovering');
    });
});